module.exports = __webpack_public_path__ + "img/rewards.b57af109.svg";